import { Button, IconButton, Tooltip } from "@aurem/ui";
import { PencilIcon } from "lucide-react";
import { useI18n } from "providers/I18nProvider";
import { useAuthorize } from "../../graphql/user";
import { useEditTranslation } from "../../providers/EditTranslationProvider";
import { PermissionEnum } from "../../types";

export const TranslationToggle = () => {
  const canManageTranslation = useAuthorize(PermissionEnum.ManageTranslation);
  const { isOn, setOn, setOff } = useEditTranslation();
  const { t } = useI18n();

  if (!canManageTranslation) {
    return null;
  }

  if (isOn) {
    return (
      <div data-translation-exclude>
        <Button
          variant="filled"
          color="primary"
          size="sm"
          startIcon={<PencilIcon size={16} />}
          onClick={setOff}
          className="bg-success-100 border-success-100 text-success-600 hover:bg-success-200 hover:border-success-200 focus-visible:bg-success-200 focus-visible:border-success-200 active:bg-success-300 active:border-success-300"
        >
          {t("apps.admin.translationMode.finishEditing")}
        </Button>
      </div>
    );
  }

  return (
    <Tooltip
      content={t("apps.admin.translationMode.editTextOnPage")}
      placement="bottom"
    >
      <IconButton variant="ghost" color="neutral" onClick={setOn}>
        <PencilIcon size={20} />
      </IconButton>
    </Tooltip>
  );
};
